import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import MultiSelectList from "../../../components/multi-select-list/multi-select-list";
import { IListItem } from "../../../interface/list-item";
import { IRootState } from "../../../redux/root.reducer";
import { useAppDispatch } from "../../../redux/store";
import { dataBrowserListSetFiltersAction } from "../redux/lists.actions";

interface IOwnProps {
    inputMask?: RegExp | string;
}

const selector = createSelector(
    (state: IRootState) => state.dataFields,
    (state: IRootState) => state.dataBrowserList.filters,
    (dataFields, filters) => ({
        options:
            dataFields.data?.map((data) => ({ id: data, name: data })) ?? [],
        isLoading: dataFields.isLoading,
        filters,
        selectedItems:
            filters.headers?.map((data) => ({ id: data, name: data })) ?? [],
    }),
);

const DataFieldsFilter = ({ inputMask }: IOwnProps) => {
    const { options, isLoading, selectedItems, filters } =
        useSelector(selector);
    const dispatch = useAppDispatch();
    const onChange = (selectedHeaders: Array<IListItem>) =>
        dispatch(
            dataBrowserListSetFiltersAction({
                ...filters,
                headers: selectedHeaders.map(({ id }) => id),
            }),
        );

    return !isLoading ? (
        <MultiSelectList
            options={options}
            selectedItems={selectedItems}
            onChange={onChange}
            multiline={true}
            clearAllOption={true}
            inputMask={inputMask}
            menuWidth={300}
        />
    ) : (
        <Skeleton />
    );
};

export default DataFieldsFilter;
